import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getAllRegionSettings,addPredefinedTextFunc, deletePredefinedTextFunc, updatePredefinedTextFunc, getPredefinedTextListFunc} from '../action/predefinedTextAction';
import PredefinedTextComponent from '../components/predefinedTextComponent';

export class PredefinedTextContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
       // this.props.actions.getPredefinedTextListFunc();
        this.props.actions.getAllRegionSettings();
    }
    getUserList = (data) =>{
                            this.props.actions.getPredefinedTextListFunc(data,
                                this.props.dispatch
                            )
                        }
    getPredefinedTextData = () =>{
        this.props.actions.getPredefinedTextListFunc(
            this.props.dispatch
        )
    }
     getRegionData = () => {
                                                     this.props.actions.getAllRegionSettings(this.props.dispatch);
                                                  }
    addPredefinedText = (payload) =>{
        this.props.actions.addPredefinedTextFunc(
            payload,
            this.props.dispatch
        )
    }
    updatePredefinedText = (payload) =>{
        this.props.actions.updatePredefinedTextFunc(
            payload,
            this.props.dispatch
        )
    }
    deletePredefinedText = (payload,RegionId) => {
        this.props.actions.deletePredefinedTextFunc(
            payload,RegionId,
            this.props.dispatch
        )
    }
    render(){
        return(
            <PredefinedTextComponent
                predefinedTextData = {this.props.predefinedTextData}
                addPredefinedText = {this.addPredefinedText}
                getPredefinedTextData = {this.getPredefinedTextData}
                deletePredefinedText = {this.deletePredefinedText}
                updatePredefinedText = {this.updatePredefinedText}
                getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
            >
            </PredefinedTextComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            addPredefinedTextFunc,
            deletePredefinedTextFunc,
            updatePredefinedTextFunc,
            getPredefinedTextListFunc,
            getAllRegionSettings
        },
            dispatch)
    };
}
function mapStateToProps({ PredefinedTextReducer }) {
    console.log(PredefinedTextReducer);
    return {
        predefinedTextData : {
            errorCode : PredefinedTextReducer.errorCode,
            statusCode : PredefinedTextReducer.statusCode,
            predefinedTextList : PredefinedTextReducer.predefinedTextList,
            message : PredefinedTextReducer.message,
            isLoading : PredefinedTextReducer.isLoading,
            regionList : PredefinedTextReducer.regionList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PredefinedTextContainer));
